import {formType} from "../../actions/form/Type";

const initialState = {
    message: null
}

const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case formType.ON_SHOW_MESSAGE:
            return {
                ...state,
                message: action.params
            }
        default:
            return state
    }
}

export default formReducer